import { memo, useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { mdlUser } from "../../models/domain/User";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEdit, faGears, faTrash } from "@fortawesome/free-solid-svg-icons";

export type UserTableProps = {
    dataSource?: mdlUser[];
    onDelete?: Function;
    onEdit?: Function;
    onCopy?: Function;
    onPermission?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    rowSelectionChange?: Function;
}

export const UserTable = memo(function UserTable(props: UserTableProps) {
    const { t } = useTranslation();

    const columns: TableProps<mdlUser>['columns'] = [
        {
            title: t("definitions.users.status"),
            key: 'isActive',

            render: (e: mdlUser) => {
                return e.isActive ? <Tag color="green">
                    {t("common.active")}
                </Tag>
                    :
                    <Tag color="orange">
                        {t("common.passive")}
                    </Tag>
            }
        },
        {
            title: t("definitions.users.userName"),
            dataIndex: 'userName',
            key: 'userName'
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (e: mdlUser, record) => (
                <Space size="middle">
                    <Button type="primary" className="btn-success" onClick={() => props.onEdit ? props.onEdit(record.id) : undefined}>
                        <FontAwesomeIcon icon={faEdit} /> {t("common.edit")}
                    </Button>
                    <Button type="primary" className="btn-second" onClick={() => props.onPermission ? props.onPermission(record.id) : undefined}>
                        <FontAwesomeIcon icon={faGears} />{t("definitions.users.permissions")}
                    </Button>
                    <Button onClick={() => props.onCopy ? props.onCopy(record.id) : undefined}>
                        <FontAwesomeIcon icon={faCopy} />{t("definitions.users.copyPermissions")}
                    </Button>
                    {e.isActive && <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            <FontAwesomeIcon icon={faTrash} /> {t("definitions.users.makePassive")}
                        </Button>
                    </Popconfirm>}
                </Space>
            ),
        },
    ];

    const handleRowDoubleClick = (e: React.MouseEvent<HTMLInputElement>, User: mdlUser) => {
        if (!$(e.target).hasClass("ant-table-row-expand-icon"))
            props.onEdit && props.onEdit(User.id);
    }

    const handleTableChange: TableProps<mdlUser>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlUser>
                    className="mt-2"
                    onRow={(reservation) => ({
                        onDoubleClick: (e) => handleRowDoubleClick(e, reservation),
                    })}
                    onChange={handleTableChange}
                    size="middle"
                    columns={columns}
                    pagination={props.pagination}
                    scroll={{ x: 'max-content' }}
                    dataSource={props.dataSource.map((customer: mdlUser, index: number) => ({ ...customer, key: index }))}
                />
            }
        </>
    )
})